<div class="payment-form">
  <h2 class="section-title ks-p-3">ACH Bank transfer</h2>

  <div class="error-message" *ngIf="validationMessage" hidden>{{ validationMessage }}</div>

  <div class="form-group">
    <label>Account Holder Name</label>
    <div id="accountNameElement" class="bt-element"></div>
    <div *ngIf="accountHolderNameEmpty" class="error-message">Account Holder Name is required</div>
  </div>

  <div class="form-group">
    <label>Bank Name</label>
    <div id="bankNameElement" class="bt-element"></div>
    <div *ngIf="bankNameEmpty" class="error-message">Bank Name is required</div>
  </div>

  <div class="row ks-p-0 ks-m-0">
    <div class="form-group half-width">
      <label>Routing Number</label>
      <div id="routingNumberElement" class="bt-element"></div>
      <div *ngIf="routingNumberEmpty" class="error-message">Routing Number is required</div>
    </div>

    <div class="form-group half-width">
      <label>Account Number</label>
      <div id="accountNumberElement" class="bt-element"></div>
      <div *ngIf="accountNumberEmpty" class="error-message">Account Number is required</div>
    </div>
  </div>

  <div class="form-group">
    <label>Zip Code</label>
    <div id="zipCodeElement" class="bt-element"></div>
  </div>

  <div *ngIf="showSavePaymentMethodOption" class="form-group">
    <div class="d-flex align-items-center">
      <mat-slide-toggle [(ngModel)]="savePaymentMethod"></mat-slide-toggle>
      <mat-label class="payment-saved"> Save Payment Method </mat-label>
    </div>
  </div>

  <button
    type="button"
    class="ks-btn-md ks-btn-primary add-payment-method-button"
    (click)="onSubmit()"
    *ngIf="showSubmitButton"
    [disabled]="isSubmitting"
  >
    <span
      inlineSVG="assets/media/svg/icons/General/white-wallet.svg"
      class="ks-mr-2 svg-icon-md"
    ></span>
    {{ isSubmitting ? 'Processing...' : 'Add account to wallet' }}
  </button>
</div>
